import { IAMapSetting, ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigAMapSettings } from "./app-settings-config-amap";

export interface IConfigAMapInputState {
  showModal: boolean;
  editingMapsId: string;
}

export interface IConfigAMapInputProps {
  parentData: string;
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigAMapInput extends PureComponent<IConfigAMapInputProps, IConfigAMapInputState> {
  formInputName: string[] = ["", "amapSettingsId"];

  constructor(props: IConfigAMapInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;

    this.state = {
      showModal: false,
      editingMapsId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingMapsId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingMaps = (id: string): void => {
    this.setState({ editingMapsId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    const {
      parentData,
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    // Rendered under both the web and the Android sections, which the Config Manager mounts at
    // once — see the Google Maps input beside it.
    const platform: string = parentData === "androidConfig" ? "android" : "web";

    const options: IAMapSetting[] = [
      { id: null, name: "Default" } as unknown as IAMapSetting,
      ...(commonSettings.amapSettings || [])
    ];
    return (
      <>
        <ConfigAMapSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingMapsId={this.state.editingMapsId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={parentData === "androidConfig" ? "android_amap_permissiontext" : "web_amap_info"}
          onAddNew={this.openModal}
          onEdit={this.setEditingMaps}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId={`${platform}AmapConfigurationDropdown`}
          addNewTestId={`${platform}AmapConfigurationAddNewButton`}
          editTestId={`${platform}AmapSettingEditButton`}
        />
      </>
    );
  }
}
